var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlassRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E7037D0E-A706-4838-8FFC-52E7BF57BADB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BOOKING-2",
    transform: "translate(-1180.000000, -692.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(10.000000, 446.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(1136.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass-regular",
    transform: "translate(34.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4658725,16.252776 C29.4658725,9.34803728 23.730081,3.75064061 16.6546236,3.75064061 C9.57916618,3.75064061 3.84337467,9.34803728 3.84337467,16.252776 C3.84337467,23.1575147 9.57916618,28.7549114 16.6546236,28.7549114 C23.730081,28.7549114 29.4658725,23.1575147 29.4658725,16.252776 L29.4658725,16.252776 Z M26.9917,28.9971402 C24.1572112,31.1928278 20.5620545,32.505552 16.6546236,32.505552 C7.45454545,32.505552 0,25.2308719 0,16.252776 C0,7.27468002 7.45454545,0 16.6546236,0 C25.8547017,0 33.3092471,7.27468002 33.3092471,16.252776 C33.3092471,20.0659273 31.964066,23.574339 29.7140904,26.3404365 L40.4355043,36.803161 C41.1881652,37.5376615 41.1881652,38.7253643 40.4355043,39.4520509 C39.6828435,40.1787375 38.4657748,40.1865514 37.721121,39.4520509 L26.9917,28.9971402 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassRegular);
export default __webpack_public_path__ + "static/media/magnifying-glass-regular.6e13d18a0f54da1a54f051f89e109dec.svg";
export { ForwardRef as ReactComponent };